<template>
	<section>
		<div class="alert alert-danger" :class="alert">{{ erro }}<br></div>
		
		<form @submit.prevent="login" class="login-form">
			<div class="form-group">
				<div class="field">
					<input type="text" id="txtLogin" class="input" required v-model="params.username" autofocus placeholder="Digite seu usuário">
					<label for="txtLogin" class="label">Login</label>
				</div>
			</div>

			<div class="form-group">
				<div class="field">
					<input type="password" id="txtSenha" class="input" required v-model="params.password" autofocus placeholder="Digite sua senha">
					<label  for="txtSenha" class="label">Senha</label>
				</div>
			</div>
					<keyboard />

			<div class="form-group mb-0 text-center">
				<button class="btn btn-sm btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2" type="submit" @click.prevent="login">Entrar</button>
			</div> 

			<div class="row mt-3">
				<div class="col-12 text-center">
					<p>Esqueceu sua senha? <router-link to="Recuperar/Senha" class="text-dark ml-1"><b>Recuperar</b></router-link></p>
				</div>
			</div>   
		</form>
	</section>
</template>

<script>
	import api 	  from '@/mixins/api.js'
	import router from '@/router/index.js'
	import keyboard from'./keyboard'

	export default {
		name: "Login",
		components: { keyboard},
		
		data() {
			return {
				alert: "hidden",
				erro: "",

				params: {
					username: "",
					password: ""
				}
			}
		},

		mixins: [api],

		computed: {
			background() {
				return this.$store.state.config.bg_login;
			}
		},

		methods: {
			async login() {
				this.params.password = $('*[id="txtSenha"]').val()
				const response = await this.POST("Auth/Login", this.params);

				if ( response.status == "error" ) {
					this.erro  = response.result;
					this.alert = "show";

					setTimeout(() => {
						this.alert = "hidden"
						this.erro  = ""
					}, 5000);
				}else {
					this.$store.dispatch("update_user", response.user );
					localStorage.auth  = true;
					localStorage.token = response.api_key;
					router.push('/App/Dashboard/Graficos');
				}
			}
		}
	}
</script>

<style lang="scss">
	@import "../../../assets/sass/login.scss";
</style>